const AUTH_API_URL =
  "https://auth-coaching-dashboard-386051205660.us-central1.run.app/auth";

export const authService = {
  async login(password) {
    try {
      const response = await fetch(AUTH_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();

      if (data.auth) {
        localStorage.setItem("isAuthenticated", "true");
        return { success: true, message: data.message };
      } else {
        return { success: false, message: data.message };
      }
    } catch (error) {
      return { success: false, message: "Network error. Please try again." };
    }
  },

  logout() {
    localStorage.removeItem("isAuthenticated");
  },

  isAuthenticated() {
    return localStorage.getItem("isAuthenticated") === "true";
  },
};
